import { InspectorPanelAccordionExport } from "../accordion/export/InspectorPanelAccordionExport"
import { InspectorPanelMetadata } from "../FlightPanelMetadata"
import { SidePanelLayer } from "@nova/constants"
import { useRulerDownloadButtonData } from "plugins/Toolbox/Ruler/useRulerDownloadButtonData"
import { useAppSelector } from "integrations/redux/hooks"
import { selectRulerById } from "features/entity-caching/rulers/selectors"

export const InspectorPanelRulerData = ({ id }: { id: string }) => {
    const ruler = useAppSelector(selectRulerById(id))
    const downloadOptions = useRulerDownloadButtonData()

    return (
        <div className="mb-2 flex flex-col gap-2">
            {/* Export */}
            <InspectorPanelAccordionExport
                exportOptions={downloadOptions.exportOptions}
                canOnlyPickOne={true}
            />

            <InspectorPanelMetadata entity={ruler as SidePanelLayer} completedUploadCount={1} />
        </div>
    )
}
